import i18n from './i18n';
import { useEffect, useState } from 'react';

type Props = {
    children: React.ReactNode;
};

const LangSettings = ({ children }: Props) => {
    const [key, setKey] = useState(0);

    useEffect(() => {
        const handleLanguageChanged = (lng: string) => {
            // Force remount of all children to ensure translations update
            setKey(prev => prev + 1);
            
            // Update document attributes
            document.documentElement.lang = lng;
            document.documentElement.setAttribute('lang', lng);
            document.documentElement.setAttribute('dir', i18n.dir(lng));
            document.documentElement.setAttribute('data-lang', lng);
        };

        // Apply immediately on mount (covers initial language load)
        const currentLang = i18n.language || 'ar';
        document.documentElement.lang = currentLang;
        document.documentElement.setAttribute('lang', currentLang);
        document.documentElement.setAttribute('dir', i18n.dir(currentLang));
        document.documentElement.setAttribute('data-lang', currentLang);

        // Keep in sync with runtime language changes
        i18n.on('languageChanged', handleLanguageChanged);
        i18n.on('loaded', () => {
            const lng = i18n.language || 'ar';
            handleLanguageChanged(lng);
        });
        
        return () => {
            i18n.off('languageChanged', handleLanguageChanged);
            i18n.off('loaded', handleLanguageChanged);
        };
    }, []);

    return <div key={key}>{children}</div>;
};

export default LangSettings;
